// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `swiper-container {
  height: calc(100% - 60px);
}

.header-md {
  box-shadow: none;
}

ion-toolbar ion-buttons {
  position: absolute;
  right: 0;
}

.zoom-img {
  object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/app/components/image-zoom/image-zoom.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;;AACA;EACE,gBAAA;AAEF;;AACE;EACE,kBAAA;EACA,QAAA;AAEJ;;AACA;EACE,iBAAA;AAEF","sourcesContent":["swiper-container {\n  height: calc(100% - 60px);\n}\n.header-md {\n  box-shadow: none;\n}\nion-toolbar {\n  ion-buttons {\n    position: absolute;\n    right: 0;\n  }\n}\n.zoom-img {\n  object-fit: cover;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
